import PropTypes from "prop-types"
import styled from "styled-components"
import { whiteTheme, borderTheme } from "../../theme"
import { cardShadow } from "../../utils/shadows"

const CardBackground = styled.div`
  display: flex;
  background-color: ${whiteTheme};
  border: 1px solid ${borderTheme};
  padding: 20px 0;
  border-radius: 10px;
  ${cardShadow()};
  overflow: hidden;
  position: relative;
    ${({ theme }) => theme.se`
    width: 100%;
    flex-direction: column;
    align-items: center;
    order: 1;
    text-align: center;

  `}

    ${({ theme }) => theme.tablet`
      width: 48%;
  `}

    ${({ theme }) => theme.desktop`
    width: 31%;

      &.padding-top-0 {
        padding-top: 0;
      }
  `}

`

CardBackground.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default CardBackground
